"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _mobx = require("mobx");
var _class;
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer && (Object.defineProperty(i, e, a), a = null), a; }
var UiStore = (_class = /*#__PURE__*/function () {
  function UiStore() {
    _classCallCheck(this, UiStore);
    _defineProperty(this, "collapsibles", _mobx.observable.map());
    _defineProperty(this, "requestId", 0);
    _defineProperty(this, "shouldScrollBeRestored", Promise.resolve(false));
    _defineProperty(this, "shouldScrollBeRestoredForNextRoute", false);
    _defineProperty(this, "snapshots", {});
    _defineProperty(this, "store", null);
    (0, _mobx.makeObservable)(this);
  }
  return _createClass(UiStore, [{
    key: "currentSnapshot",
    get: function get() {
      return this.snapshots[this.store.router.currentPath];
    }
  }, {
    key: "restoreScroll",
    value: function restoreScroll(fallback) {
      var currentSnapshot = this.currentSnapshot;
      if (currentSnapshot) {
        this.scrollTo(currentSnapshot.scrollX, currentSnapshot.scrollY);
      } else if (typeof fallback === 'function') {
        var _fallback = fallback(),
          scrollX = _fallback.scrollX,
          scrollY = _fallback.scrollY;
        this.scrollTo(scrollX, scrollY);
      } else {
        this.scrollTo(0, 0);
      }
    }
  }, {
    key: "saveScrollFor",
    value: function saveScrollFor(path) {
      var _window = window,
        scrollX = _window.scrollX,
        scrollY = _window.scrollY;
      this.snapshots[path] = {
        scrollX: scrollX,
        scrollY: scrollY
      };
    }
  }, {
    key: "setStore",
    value: function setStore(store) {
      this.store = store;
    }
  }, {
    key: "scrollTo",
    value: function scrollTo(x, y) {
      if (this.requestId !== 0) {
        window.cancelAnimationFrame(this.requestId);
      }
      this.requestId = window.requestAnimationFrame(function () {
        window.scrollTo(x, y);
      });
    }
  }, {
    key: "initCollapsible",
    value: function initCollapsible(id, defaultValue) {
      if (this.collapsibles.get(id) === undefined) {
        this.collapsibles.set(id, defaultValue);
      }
    }
  }, {
    key: "toggleCollapsible",
    value: function toggleCollapsible(id) {
      this.collapsibles.set(id, !this.isCollapsed(id));
    }
  }, {
    key: "isCollapsed",
    value: function isCollapsed(id) {
      return this.collapsibles.get(id);
    }
  }]);
}(), (_applyDecoratedDescriptor(_class.prototype, "currentSnapshot", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "currentSnapshot"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "initCollapsible", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "initCollapsible"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleCollapsible", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleCollapsible"), _class.prototype)), _class);
var _default = exports["default"] = UiStore;
//# sourceMappingURL=ui.js.map